import Component from '@glimmer/component';

/*
  attrs
    - links = [{
      route:
      models:
      label:
    }]
*/

export default class extends Component {}
